import { gql } from "@apollo/client";

export const PET_COLORS = gql`
  query getPetColors($data: PetColorInput!) {
    getPetColors(
      data: $data
    ) {
      colors {
        id,
        name,
      },
      messages,
      success,
    }
  }
`;
